import React, { useRef } from 'react'

const RemoteControlVideo = ({ videoRef, handleClick, handleDoubleClick, handleSwipe, handleLongPress, ...props }) => {
	const coordPrecision = 4
	const coordDiffThreashold = 20

	const singleClickTimeout = useRef()
	const longPressTimeout = useRef()
	const mouseDownCoords = useRef()

	const coordsDiff = (x1, x2) => Math.abs(x1 - x2) > coordDiffThreashold
	const isSwipe = ([c1, c2]) => coordsDiff(c1.x, c2.x) || coordsDiff(c1.y, c2.y)
	const calcCoordinates = ({ x, y }) => {
		const streamPlayer = document.getElementById(props.id)
		const rect = streamPlayer.getBoundingClientRect()
		const calculation = (coordinate, offset, total, precision) => Math.round((coordinate - Math.round(offset)) / (total / 100) * (Math.pow(10, precision))) / (Math.pow(10, precision))
		return {
			x: calculation(x, rect.left, rect.width, coordPrecision),
			y: calculation(y, rect.top, rect.height, coordPrecision)
		}
	}

	const handleOnDoubleClick = e => {
		const coords = {
			x: e.clientX,
			y: e.clientY
		}
		clearTimeout(singleClickTimeout.current)
		if(typeof handleDoubleClick === 'function') {
			handleDoubleClick(calcCoordinates(coords))
		}
	}

	const handleMouseDown = e => {
		const coords = {
			x: e.clientX,
			y: e.clientY
		}
		mouseDownCoords.current = coords
		longPressTimeout.current = setTimeout(() => {
			longPressTimeout.current = true
			if(typeof handleLongPress === 'function') {
				handleLongPress(calcCoordinates(coords))
			}
		}, 1000)
	}
	const handleMouseUp = e => {
		const coords = {
			x: e.clientX,
			y: e.clientY
		}
		const swipeCoords = [calcCoordinates(mouseDownCoords.current), calcCoordinates(coords)]
		if(isSwipe(swipeCoords)) {
			if(typeof handleLongPress === 'function') {
				handleSwipe(swipeCoords)
			}
			return clearTimeout(longPressTimeout.current)
		}
		if(longPressTimeout.current === true) {
			return
		}
		clearTimeout(longPressTimeout.current)
		if (e.detail === 1) {
	    singleClickTimeout.current = setTimeout(() => {
	      if(typeof handleClick === 'function') {
					handleClick(calcCoordinates(coords))
				}
	    }, 200)
	  }
	}

	return (
		<video
			{...props}
			ref={videoRef}
			onDoubleClick={handleOnDoubleClick}
			onMouseDown={handleMouseDown}
			onMouseUp={handleMouseUp}
		/>
	)
}

export default RemoteControlVideo
